import * as types from './mutation-types'
export default {
  SET_COMMUNITY_NAME (state, name) {
    state.communityName = name
  },
  SET_CITY_NAME (state, name) {
    state.cityName = name
  },
  SET_CITY_ID (state, id) {
    state.cityId = id
  },
  SET_SHOW_LEFT_BOTTOM_BTN (state, type) {
    state.showLeftBottomBtn = type
  },
  SET_SHOW_HOME_BOTTOM_BAR (state, type) {
    state.showHomeBottomBar = type
  },
  CLEAR_ACCESS_TOKEN (state) {
    state.sdk.accessToken = ''
  },
  CONNECT_TOKEN_FAIL (state) {
    state.connectTokenFail = true
  },
  SET_NO_COUPON_COST (state, noCouponCost) {
    state.noCouponCost = noCouponCost
  },
  SET_QUICK_COST (state, cost) {
    state.cost = cost
  },
  SET_QUICK_COUPON (state, { quickCoupon }) {
    state.quickCouponObj = quickCoupon
  },
  SET_QUICK_COUPON_LIST (state, { playLoadCoupon }) {
    state.quickCouponList = playLoadCoupon
  },
  SET_CONFIRM_ORDER_INFO (state, orderInfo) {
    state.confirmOrderInfo = orderInfo
  },
  SET_CONFIRM_ORDER_DETAIL (state, { arr }) {
    state.confirmOrderDetail = arr
  },
  SET_COUPON_LIST (state, { playLoadCoupon }) {
    state.couponListObj = playLoadCoupon
  },
  SET_CONFIRM_ORDER_PARAMS (state, { playLoad }) {
    state.confirmOrderParams = playLoad
  },
  SET_CLIENT_ID (state, clientId) {
    state.clientId = clientId
  },
  SET_PICK_ITEM (state, { playLoad }) {
    state.pickItem = playLoad
  },
  [types.SET_API_TOGGLE_INIT] (state, { apiAction }) {
    state.api[apiAction].toggle.setInit()
  },
  [types.SET_API_TOGGLE_LOADING] (state, { apiAction }) {
    state.api[apiAction].toggle.setLoading()
  },
  [types.SET_API_TOGGLE_SUCCESS] (state, { apiAction }) {
    state.api[apiAction].toggle.setSuccess()
  },
  [types.SET_API_TOGGLE_FAIL] (state, { apiAction }) {
    state.api[apiAction].toggle.setFail()
  },
  [types.SET_API_TOGGLE_EMPTY] (state, { apiAction }) {
    state.api[apiAction].toggle.setEmpty()
  },
  [types.SET_API_DATA] (state, { apiAction, data }) {
    state.api[apiAction].data = data
  },
  [types.SET_SDK_DATA] (state, obj) {
    Object.assign(state.sdk, obj)
  },
  [types.SET_USER_INFO] (state, obj) {
    Object.assign(state.userInfo, obj)
  },
  [types.SET_COMMUNITY_INFO] (state, obj) {
    Object.assign(state.communityInfo, obj)
  },
  [types.SET_SERVICE_INFO] (state, obj) {
    Object.assign(state.serviceInfo, obj)
  },
  [types.SET_STORE_INFO] (state, obj) {
    Object.assign(state.storeInfo, obj)
  },
  [types.SET_DIALOG_VISIBLE] (state, { name, visible }) {
    state.dialogVisible[name] = visible
  },
  [types.INIT_TROLLEY] (state) {
    state.trolley = []
  },
  [types.SET_CART] (state, {cartList}) {
    state.cartList = cartList
  },
  [types.SET_TROLLEY] (state, { product }) {
    let [isFound, i] = [false, 0]
    for (i; i < state.trolley.length; i++) {
      if (product.id === state.trolley[i].id) {
        isFound = true
        break
      }
    }
    if (isFound) {
      if (parseInt(product.count) > 0) {
        state.trolley[i].count = parseInt(product.count)
      } else {
        state.trolley.splice(i, 1)
      }
    } else {
      let obj = {}
      Object.assign(obj, product)
      state.trolley.push(obj)
    }
  }
}
